import React, { useEffect, useState } from "react";
import ApplicationInfo from "../../Pages/Submitter/MainResearcherInformation/ApplicationInfo";
import SharedDiv from "../../Components/SharedDiv/SharedDiv";
import MainResearcherInfor from "../../Pages/Submitter/MainResearcherInformation/MainResearcherInfo";
import InformationAboutScientificInstitution from "../../Pages/Submitter/MainResearcherInformation/InformationAboutScientificInstitution";
import PublishedScientificResearch from "../../Pages/Submitter/MainResearcherInformation/PublishedScientificResearch";
import AcademicQualifications from "../../Pages/Submitter/MainResearcherInformation/AcademicQualifications";
import Patents from "../../Pages/Submitter/MainResearcherInformation/Patents";
import ResearchExperience from "../../Pages/Submitter/MainResearcherInformation/ResearchExperience";
import GeneralInformation from "../../Pages/Submitter/MainResearcherInformation/GeneralInformation";
import ButtonAHSF from "../../Components/ButtonAHSF";
import { useDispatch, useSelector } from "react-redux";
import Swal from "sweetalert2";
import $ from "jquery";
import {
  setValidateMainResearcherPageList,
    UpdateMainResarcherPage,
  ValidateMainResearcherPage,
} from "../../Redux/Reducers/Submitter/MainResearcherInformation";
import PopupAHSF from "../../Components/PopupAHSF";
import { useLocation, useNavigate } from "react-router-dom";
import { decryptToken } from "../../Services/Encryption/EncryptionParams";

const MainResearcherInformainContainer = (props) => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const state = useSelector((state) => {
    return {
      MainResearcherInformation:
        state.MainResearcherInformation.MainResearcherInformain,
      InfoScientificFoundation:
        state.InformationAboutScientificInstitution.InfoScientificFoundation,
      jsonData: state.FetchDataJson.JsonData,
      ValidateMainResearcherPageList:
        state.MainResearcherInformation.ValidateMainResearcherPageList,
    };
  });
  const ActiveRound = useSelector((state) => state.RoundReducers.ActiveRound);
  const ApplicationInformation = useSelector(
    (state) => state.ApplicationInformationReducers.ApplicationInformation
  );

  const [isPopupOpenStatus, setisPopupOpenStatus] = useState(false); // Popup visibility state
  console.log(ActiveRound, "ActiveRound", ApplicationInformation);

const shouldDisableFields = !(

    ApplicationInformation?.sU_ST_MRI_ApplicationStatus?.applicationStatusId == "57ca8392-5b8e-4625-8a37-00dfc27d5b28" ? true :
      ActiveRound == ApplicationInformation?.aI_RoundYearId &&
      ApplicationInformation?.sU_ST_MRI_ApplicationStatus?.canEdit &&
      window.location.href.includes("manager") == false
  );
  // Function to handle data saving
  const SaveDataPage = async (withValidate) => {
    const saved = await dispatch(
      UpdateMainResarcherPage({
        sU_NT_MRI_MainResearcherInformainUpdateModel:
          state.MainResearcherInformation,
        sU_NT_MRI_InformationAboutTheScientificFoundationUpdateModel:
          state.InfoScientificFoundation,
      })
    );

    if (withValidate == true && saved.payload) {
      // If validation is required and data is saved
      const validate = await dispatch(
        ValidateMainResearcherPage(
          localStorage.getItem("ApplicationInformationId")
        )
      );
      // GetValidatetateApplicationInformationPage(
      //   localStorage.getItem("aI_ApplicationInformationId") // Validate based on application ID
      // )

      if (validate.payload.length == 0) {
        // If validation passes, navigate to the next page

        $(".ResearchProposalInformation").trigger("click");

        navigate("/SRFund/ResearchProposalInformation");
      } else {
        setisPopupOpenStatus(true); // Show popup if validation fails
      }
    }
  };
  console.log(   ActiveRound , ApplicationInformation?.aI_RoundYearId ,
    ApplicationInformation?.sU_ST_MRI_ApplicationStatus?.canEdit,"dffdffdfdffddfdfdfdff");
  
  useEffect(() => {
    dispatch(setValidateMainResearcherPageList([]));
  }, []);
  // to read params url
  const location = useLocation();
  // استخراج GUID باستخدام Regular Expression
  const match = window.location.pathname; // قراءة النص بعد أول "/"
  const encryptedToken = match.split("/");
    var guid =
      encryptedToken[encryptedToken.length - 1] != null
        ? decryptToken(encryptedToken[encryptedToken.length - 1])
        : null;
        console.log(guid, "slkdslkdlksdl");
  return (
    <>
      <SharedDiv
        showTitle={true}
        titleName="معلومات الطلب"
        child={[<ApplicationInfo applicationGuid={guid} />]}
      />

      <SharedDiv
        showTitle={true}
        titleName=" معلومات الباحث الرئيسي"
        child={[
          <MainResearcherInfor applicationGuid={guid} shouldDisableFields={shouldDisableFields} />,
        ]}
      />

      <SharedDiv
        showTitle={true}
        titleName="معلومات المؤسسة العلمية التي يتبع لها مقدم الطلب"
        child={[
          <InformationAboutScientificInstitution
          applicationGuid={guid}
            shouldDisableFields={shouldDisableFields}
          />,
        ]}
      />
      {ApplicationInformation?.aI_RoundYearId ?<>
      <SharedDiv
        showTitle={true}
        titleName="المؤهلات العلمية"
        child={[
          <AcademicQualifications 
          applicationGuid={guid}
          
          shouldDisableFields={shouldDisableFields} />,
        ]}
      />
      <SharedDiv
        showTitle={true}
        titleName="الأبحاث العلمية المنشورة"
        child={[
          <PublishedScientificResearch
          applicationGuid={guid}
            shouldDisableFields={shouldDisableFields}
          />,
        ]}
      />
      <SharedDiv
        showTitle={true}
        titleName="  الخبرات البحثية"
        child={[
          <ResearchExperience 
          applicationGuid={guid}
          shouldDisableFields={shouldDisableFields} />,
        ]}
      />
      <SharedDiv
        showTitle={true}
        titleName=" براءات الأختراع"
        child={[<Patents
          applicationGuid={guid}
          
          shouldDisableFields={shouldDisableFields} />]}
      />
</>:""}

      <SharedDiv
        showTitle={true}
        titleName="معلومات عامة"
        child={[
          <GeneralInformation 
          applicationGuid={guid}
          
          shouldDisableFields={shouldDisableFields} />,
        ]}
      />
      {!shouldDisableFields ? (
        <div className="containerButtonMAin">
          {/* Render Save button */}
          <ButtonAHSF
            type={"submitter"}
            onClick={() => {
              SaveDataPage(false); // Save without validation
              Swal.fire({
                position: "center",
                icon: "success",
                title: "تم حفظ المعلومات بنجاح",
                showConfirmButton: false,
                timer: 1000,
              });
            }}
            disabled={false}
            title={"حفظ"}
            text={"حفظ"}
            show={true}
          />
          {/* Render Next button */}
          <ButtonAHSF
            type={"submitter"}
            onClick={() => {
              SaveDataPage(true); // Save with validation
            }}
            disabled={false}
            title={"التالي"}
            text={"التالي"}
            show={true}
          />
        </div>
      ) : (
        ""
      )}
      <PopupAHSF
        isPopupOpenStatus={isPopupOpenStatus}
        isPopupOpenFunction={() => setisPopupOpenStatus(false)} // Close popup
        forValidate={true}
        maxWidth="50%"
        title="يرجى تعبئة الحقول المطلوبة"
        componentBody={state.ValidateMainResearcherPageList} // Validation messages
      />
    </>
  );
};

export default MainResearcherInformainContainer;
